import React, { useEffect } from 'react'
import Axios from 'axios'
import {useState} from 'react'
import { useForm } from "react-hook-form";
import HolidayVillageIcon from '@mui/icons-material/HolidayVillage';
import BadgeIcon from '@mui/icons-material/Badge';
import EmailIcon from '@mui/icons-material/Email';
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import DirectionsWalkIcon from '@mui/icons-material/DirectionsWalk';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import InterestsIcon from '@mui/icons-material/Interests';
import './CRM.css'



export const CRMForm = () => {
const Swal = require('sweetalert2');
useEffect(() => {
  const token = localStorage.getItem('token')
  fetch('http://27.254.66.164:5000/Author',{
  method: 'POST',
  mode: 'cors',
  headers: {
      'Authorization': 'Bearer '+token,
      'Content-Type': 'application/json',
  },
})
.then(response => response.json())
.then(data => {
      if (data.status === 'ok'){
      } else {
        Swal.fire({
          title: 'กรุณาเข้าสู่ระบบอีกครั้ง',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          confirmButtonText: 'ตกลง',
        }).then((result) => {
          if (result.isConfirmed) { 
            window.location.href = '/ec-crm/Login'
          }
        })
      }
  });
},[])
 let  defaultDate = new Date()
 defaultDate.setDate(defaultDate.getDate())
 const [CustomerName, setName] = useState(""); 
 const [Phone, setPhone] = useState("");
 const [Email, setEmail] = useState("");
 const [date, setDate] = useState(defaultDate);
 const [CrmCustomerId, setCrmCustomerId] = useState("");
 const [LineID, setLineID] = useState("");
 const [StatusQues, setStatusQues] = useState("");
 const [ProjectId, setProjectId] = useState("");
 const [TypeCus, setTypeCus] = useState("");
 const [Grade, setGrade] = useState("");
 const [CustomerList, setCustomerList] = useState([]);
 const [ProjectList, setProjectList] = useState([]);
 const [Customer, setCustomer] = useState("");
 const { register, handleSubmit } = useForm({});
 const [EmployeeType, setEmployeeType] = useState("");
 const [EmpId, setEmpId] = useState("");
 useEffect(() => {
  const EmployeeType = JSON.parse(localStorage.getItem('EmployeeType'));
  if (EmployeeType) {
    setEmployeeType(EmployeeType);
   }
},[setEmployeeType]);
useEffect(() => {
  const EmpId = JSON.parse(localStorage.getItem('EmpId'));
  if (EmpId) {
    setEmpId(EmpId);
   }
},[setEmpId]);
 var CryptoJS = require("crypto-js/core");
 CryptoJS.AES = require("crypto-js/aes");
 var secret = "Ec";
useEffect(()=> {
  const fetch = async () => {
      try {
          Axios.get('http://27.254.66.164:5000/cusserch').then((response) => {
            setCustomerList(response.data);
          });
      } catch (error) {
          console.error(error)
      }
  }
  fetch()
},[])
// async function fetchComments() {
//   Axios.get('http://27.254.66.164:5000/CrmTd').then((response) => {
//        setCustomer(response.data);
//   });
// }
useEffect(() => {
  Axios.post('http://27.254.66.164:5000/projectserch',{
    EmployeeType:EmployeeType,
    EmpId:EmpId
  }).then((response) => {
    setProjectList(response.data);
  });
}, [EmployeeType,EmpId]);
// useEffect(() => {
//   fetchComments();
// }, []);
const onSetDate = (event) => {
  setDate(new Date(event.target.value))
}
const PersonNames = key => { 
    setCrmCustomerId(CustomerList.filter(person => person.CrmCustomerId === key).map(person => person.CrmCustomerId));
    const CusName = CustomerList.filter(person => person.CrmCustomerId === key).map(person => person.CustomerName).toString();
    const decryptCusName = CryptoJS.AES.decrypt(CusName,secret).toString(CryptoJS.enc.Utf8);
    const CustomerName = decryptCusName.substring(1, decryptCusName.length - 1);
    const Phone1 =CustomerList.filter(person => person.CrmCustomerId === key).map(person => person.Phone).toString();;
    const decryptPhone = CryptoJS.AES.decrypt(Phone1,secret).toString(CryptoJS.enc.Utf8);
    const Phone = decryptPhone.substring(1, decryptPhone.length - 1);
    const Emaill = CustomerList.filter(person => person.CrmCustomerId === key).map(person => person.Email).toString();;
    const decryptEmail = CryptoJS.AES.decrypt(Emaill,secret).toString(CryptoJS.enc.Utf8);
    const Email = decryptEmail.substring(1, decryptEmail.length - 1);
    const Line = CustomerList.filter(person => person.CrmCustomerId === key).map(person => person.LineID).toString();;
    const decryptLine = CryptoJS.AES.decrypt(Line,secret).toString(CryptoJS.enc.Utf8);
    const LineID = decryptLine.substring(1, decryptLine.length - 1);
    setLineID(LineID);
    setName(CustomerName);
    setPhone(Phone);
    setEmail(Email);
    setStatusQues(CustomerList.filter(person => person.CrmCustomerId === key).map(person => person.StatusQues));
};

const AddCustomer = () => {
  if(StatusQues.toString()=== "0" || StatusQues.toString() === ""){
    Axios.post('http://27.254.66.164:5000/addcus', {
      EmpId: EmpId,
      ProjectId : ProjectId,
      CrmCustomerId : CrmCustomerId,
      CustomerDate: date,
      CustomerName: CustomerName,
      Phone: Phone,
      Email: Email,
      LineID: LineID,
      TypeCus: TypeCus,
      Grade: Grade
    }).then((response) => {
      setCustomerList([
          ...CustomerList,
        {
          EmpId: EmpId,
          ProjectId : ProjectId,
          CrmCustomerId : CrmCustomerId,
          CustomerDate: date,
          CustomerName: CustomerName,
          Phone: Phone,
          Email: Email,
          LineID: LineID,
          TypeCus: TypeCus,
          Grade: Grade
        }
      ])
      const numbers =response.data;
      const CRMID = (numbers.map(x => x.CrmCustomerId).flat().toString());
      Swal.fire({
        title: 'คุณพร้อมจะกรอกฟอร์มลูกค้าหรือยัง ?',
        text: "ถ้าลูกค้าคนนี้เคยกรอกฟอร์มไว้แล้วจะไม่แสดงข้อความนี้",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'ไปทำฟอร์ม',
        cancelButtonText: 'กลับสู่หน้าแรก'
      }).then((result) => {
        
        if (result.isConfirmed) { 
            if(CrmCustomerId === ""){
              window.location.href = '/ec-crm/Form?CustomerId='+CRMID;
            }else{
              window.location.href = '/ec-crm/Form?CustomerId='+CrmCustomerId;
            }
        }else if (result.dismiss === Swal.DismissReason.cancel) {
            window.location.href = '/ec-crm/';
        }
      })
    });
  }else{
    Axios.post('http://27.254.66.164:5000/addcus', {
      ProjectId : ProjectId,
      EmpId: EmpId,
      CrmCustomerId : CrmCustomerId,
      CustomerName: CustomerName,
      CustomerDate: date,
      Phone: Phone,
      Email: Email,
      LineID: LineID,
      TypeCus: TypeCus,
      Grade: Grade
    }).then(() => {
      setCustomerList([
          ...CustomerList,
        {
          ProjectId : ProjectId,
          EmpId: EmpId,
          CrmCustomerId : CrmCustomerId,
          CustomerName: CustomerName,
          CustomerDate: date,
          Phone: Phone,
          Email: Email,
          LineID: LineID,
          TypeCus: TypeCus,
          Grade: Grade
        }
      ])
    });
    Swal.fire({
      title: 'สำเร็จ',
      text: "ลูกค้าคนนี้เคยกรอกฟอร์มไว้แล้ว",
      icon: 'success',
      showConfirmButton: false,
      timer: 1500
    }).then(() => {
          window.location.href = '/ec-crm/';
    })
  }
  
}

  return (
    <div className="container">
      <br></br> 
      <h2 align="center">กรอกข้อมูลลูกค้า</h2>
      <br></br> 
        <div className="center">
            <form  onSubmit={handleSubmit(AddCustomer)}  align="center">
                                  <div className="row justify-content-md-center">  
                                    <div className="col col-lg-3" >
                                      <label htmlFor='ProjectId' className='visually-hidden'>โครงการ</label>
                                      <div className="input-group">
                                      <span className="input-group-text"><HolidayVillageIcon /></span>
                                      <select className='form-control'  value={ProjectId} multiple={false} onChange={e => setProjectId(e.target.value)}>
                                            <option value="">กรุณาเลือกโครงการ</option>
                                            {
                                              ProjectList.map( (x,key) => 
                                              <option key={key} value={x.ProjectId}>{ x.ProjectShortName+" : "+x.ProjectName}</option> )
                                            }
                                      </select>
                                      </div>
                                    </div>
                                    <div className="col col-lg-3" >
                                      <label htmlFor='CustomerDate' className='visually-hidden'>วันที่</label>
                                      <div className="input-group date" data-provide="datepicker">
                                        <span className="input-group-text"><CalendarMonthIcon /></span>
                                        <input type="date" className='form-control' value={date.toISOString().substring(0, 10)} onChange={onSetDate} data-date-end-date="0d" />
                                      </div>
                                    </div>
                                  </div>  
                                  <br></br>
                                  <div className="row justify-content-md-center">  
                                    <div className="col col-lg-6" >
                                      <label htmlFor='CustomerName' className='visually-hidden'>ชื่อ-นามสกุล</label>
                                      <div className="input-group">
                                      <span className="input-group-text"><BadgeIcon /></span>
                                        <input type="text" className='form-control' placeholder="ชื่อ-นามสกุล" {...register("CustomerName",{ required: true })} value={CustomerName} onChange={event => setName(event.target.value)}/>
                                              {
                                                CustomerList.filter(post => {
                                                  if (CustomerName === '') {
                                                    return CryptoJS.AES.decrypt(post.CustomerName,secret).toString(CryptoJS.enc.Utf8).substring(1, CryptoJS.AES.decrypt(post.CustomerName,secret).toString(CryptoJS.enc.Utf8).length - 1).includes(setName);
                                                  }else{
                                                    return CryptoJS.AES.decrypt(post.CustomerName,secret).toString(CryptoJS.enc.Utf8).substring(1, CryptoJS.AES.decrypt(post.CustomerName,secret).toString(CryptoJS.enc.Utf8).length - 1).toString().toLowerCase().includes(CustomerName);
                                                  }
                                                }).map((post) => (
                                                  <div className="dataItem" key={post.CrmCustomerId}>
                                                    <a href onClick={() => PersonNames(post.CrmCustomerId)}>{CryptoJS.AES.decrypt(post.CustomerName,secret).toString(CryptoJS.enc.Utf8).substring(1, CryptoJS.AES.decrypt(post.CustomerName,secret).toString(CryptoJS.enc.Utf8).length - 1)+" | ประเภทลูกค้า(โครงการ) :"+post.TypeCusPro}</a>
                                                  </div>                       
                                                ))
                                              }
                                      </div>
                                    </div>
                                  </div>
                                  <br></br>
                                  <div className="row justify-content-md-center"> 
                                   <div className="col col-lg-6" >
                                      <label htmlFor='Phone' className='visually-hidden'>เบอร์โทรศัพท์</label>
                                      <div className="input-group">
                                        <span className="input-group-text"><LocalPhoneIcon /></span>
                                          <input type="text" className='form-control' onKeyPress={(event) => {if (!/[0-9]/.test(event.key)) {event.preventDefault();}}} value={Phone} placeholder="เบอร์โทรศัพท์" onChange={(e) => {
                                              setPhone(e.target.value)
                                            }}/>
                                      </div>
                                    </div>
                                  </div>
                                  <br></br>
                                  <div className="row justify-content-md-center"> 
                                   <div className="col col-lg-6" >
                                      <label htmlFor='Email' className='visually-hidden'>อีเมล :</label>
                                      <div className="input-group">
                                          <span className="input-group-text"><EmailIcon /></span>
                                          <input type="text" className='form-control' value={Email} placeholder="อีเมล" onChange={(e) => {
                                              setEmail(e.target.value)
                                            }}/>
                                      </div>
                                    </div>
                                  </div>
                                  <br></br>
                                  <div className="row justify-content-md-center"> 
                                    <div className="col col-lg-6" >
                                    <label htmlFor='LineID' className='visually-hidden'>LineID :</label>
                                      <div className="input-group">
                                        <span className="input-group-text"><img src = {require('./../img/line.png')} width="25" height="25"  alt="logo" /></span>
                                          <input type="text" className='form-control' value={LineID} placeholder="ไอดีไลน์" onChange={(e) => {
                                              setLineID(e.target.value)
                                            }}/>
                                      </div>
                                    </div>
                                  </div>
                                  <br></br>
                                  <div className="row justify-content-md-center"> 
                                   <div className="col col-lg-6" >
                                      <label htmlFor='TypeCus' className='visually-hidden'>ประเภทลูกค้า</label>
                                      <div className="input-group">
                                        <span className="input-group-text"><DirectionsWalkIcon /></span>
                                        <select className='form-control'  value={TypeCus} multiple={false} onChange={e => setTypeCus(e.target.value)}>
                                                <option value="">กรุณาเลือกประเภทลูกค้า</option>
                                                <option value="1">Walk-In</option>
                                                <option value="2">Call</option>
                                                <option value="3">Online Contract</option>
                                                <option value="4">Walk-in Online</option>
                                        </select>
                                      </div>
                                   </div>
                                  </div>
                                  <br></br>
                                  <div className="row justify-content-md-center"> 
                                   <div className="col col-lg-6" >
                                      <label htmlFor='Grade' className='visually-hidden'>ความสนใจของลูกค้า</label>
                                      <div className="input-group">
                                        <span className="input-group-text"><InterestsIcon /></span>
                                        <select className='form-control'  value={Grade} multiple={false} onChange={e => setGrade(e.target.value)}>
                                                <option value="">กรุณาเลือกความสนใจของลูกค้า</option>
                                                <option value="2">สนใจ</option>
                                                <option value="1">สนใจปานกลาง</option>
                                                <option value="0">ไม่สนใจ</option>
                                        </select>
                                      </div>
                                   </div>
                                  </div>
                              
                                <br></br>
                                <button type='submit' className='btn btn-success'>เพิ่มข้อมูลลูกค้า</button>
            </form>                  
        </div>                
    </div>
  );
}

